export default {
  name: {
    id: 'us_telco_comparators_us_mobile_offer_card_name',
    defaultMessage: 'US Mobile',
  },
  promoTitle: {
    id: 'us_telco_comparators_us_mobile_offer_card_promo_title',
    defaultMessage: '$100 off your phone',
  },
  promoContent: {
    id: 'us_telco_comparators_us_mobile_offer_card_promo_content',
    defaultMessage:
      'Save on any Back Market phone when you buy any unlimited plan.',
  },
  benefitNetworks: {
    id: 'us_telco_comparators_us_mobile_offer_card_benefit_networks',
    defaultMessage: 'Switch between AT&T, T-Mobile, or Verizon networks',
  },
  benefitUnlimited: {
    id: 'us_telco_comparators_us_mobile_offer_card_benefit_unlimited',
    defaultMessage: 'Unlimited data, call and text',
  },
  benefitInternational: {
    id: 'us_telco_comparators_us_mobile_offer_card_benefit_international',
    defaultMessage: 'International Data',
  },
  modalStep1: {
    id: 'us_telco_comparators_us_mobile_offer_card_modal_step_1',
    defaultMessage:
      "Sign up for a plan on US Mobile's site. Find the promo code in your US Mobile account at the top of your dashboard.",
  },
  modalStep2: {
    id: 'us_telco_comparators_us_mobile_offer_card_modal_step_2',
    defaultMessage:
      'Select and customize the unlocked phone you want on Back Market.',
  },
  modalStep3: {
    id: 'us_telco_comparators_us_mobile_offer_card_modal_step_3',
    defaultMessage: 'Apply your code at checkout.',
  },
  modalCtaLabel: {
    id: 'us_telco_comparators_us_mobile_offer_card_modal_cta_label',
    defaultMessage: 'Get started on US Mobile',
  },
  modalCtaLink: {
    id: 'us_telco_comparators_us_mobile_offer_card_modal_cta_link',
    defaultMessage: 'https://www.usmobile.com/refurbished/backmarket',
  },
}
